import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import ScoreReport from './ScoreReport';

// Part 2话题库（英文）
export const PART2_TOPICS = [
  {
    instruction: "Describe a person who has had an important influence on your life",
    prompts: [
      "Who this person is",
      "How you met them",
      "Why they influenced you",
      "How you feel about them"
    ]
  },
  {
    instruction: "Describe a book you have recently read",
    prompts: [
      "What the book was about",
      "When you read it",
      "Why you decided to read it",
      "How you felt about it"
    ]
  },
  {
    instruction: "Describe a place you have visited that impressed you",
    prompts: [
      "Where the place is",
      "When you went there",
      "What you did there",
      "Why it impressed you"
    ]
  },
  {
    instruction: "Describe a skill you would like to learn",
    prompts: [
      "What the skill is",
      "How you would learn it",
      "Why you want to learn it",
      "How this skill would be useful to you"
    ]
  },
  {
    instruction: "Describe a special gift you have received",
    prompts: [
      "What the gift was",
      "Who gave it to you",
      "Why they gave it to you",
      "How you felt when you received it"
    ]
  },
  {
    instruction: "Describe a historical period you would like to know more about",
    prompts: [
      "What period it is",
      "How you know about it",
      "Why you are interested in it",
      "What you would like to know about it"
    ]
  },
  {
    instruction: "Describe an important decision you have made",
    prompts: [
      "What the decision was",
      "When you made this decision",
      "How you made your decision",
      "How this decision changed your life"
    ]
  },
  {
    instruction: "Describe a traditional festival in your country",
    prompts: [
      "What the festival celebrates",
      "When it is celebrated",
      "How people celebrate it",
      "Why you like/dislike this festival"
    ]
  },
  {
    instruction: "Describe a technology that is important in your daily life",
    prompts: [
      "What the technology is",
      "When you started using it",
      "How often you use it",
      "Why it is important to you"
    ]
  },
  {
    instruction: "Describe a time when you helped someone",
    prompts: [
      "Who you helped",
      "How you helped them",
      "Why you helped them",
      "How you felt afterward"
    ]
  },
  // 以下是新增的25道Part 2话题卡片
  {
    instruction: "Describe a memorable journey you have taken",
    prompts: [
      "Where you went",
      "Who you went with",
      "What happened during the journey",
      "Why it was memorable"
    ]
  },
  {
    instruction: "Describe an item of clothing that is special to you",
    prompts: [
      "What the item is",
      "When you got it",
      "Why it is special to you",
      "How often you wear it"
    ]
  },
  {
    instruction: "Describe a museum or art gallery you have visited",
    prompts: [
      "Where it is located",
      "What kind of museum or gallery it is",
      "What you saw there",
      "How you felt about the experience"
    ]
  },
  {
    instruction: "Describe a teacher who has influenced you",
    prompts: [
      "Who this teacher is/was",
      "What subject they taught",
      "What was special about them",
      "How they influenced you"
    ]
  },
  {
    instruction: "Describe a time when you had to work hard to achieve a goal",
    prompts: [
      "What the goal was",
      "Why you wanted to achieve it",
      "How you worked toward it",
      "How you felt when you achieved it"
    ]
  },
  {
    instruction: "Describe a hobby you enjoy",
    prompts: [
      "What the hobby is",
      "How you became interested in it",
      "How often you do it",
      "Why you enjoy it"
    ]
  },
  {
    instruction: "Describe a beautiful place in nature you have visited",
    prompts: [
      "Where it is",
      "When you went there",
      "What you did there",
      "Why you think it is beautiful"
    ]
  },
  {
    instruction: "Describe a time when you gave advice to someone",
    prompts: [
      "Who you gave advice to",
      "What the advice was about",
      "Why you gave the advice",
      "What happened as a result"
    ]
  },
  {
    instruction: "Describe a creative person whose work you admire",
    prompts: [
      "Who this person is",
      "How you know about them",
      "What kind of creative work they do",
      "Why you admire their work"
    ]
  },
  {
    instruction: "Describe a useful website you visit",
    prompts: [
      "What kind of website it is",
      "How often you visit it",
      "What you use it for",
      "Why you find it useful"
    ]
  },
  {
    instruction: "Describe a piece of good news you received recently",
    prompts: [
      "What the news was",
      "How you received it",
      "How you felt about it",
      "Why it was important to you"
    ]
  },
  {
    instruction: "Describe a time when you tried a new food",
    prompts: [
      "What the food was",
      "Where you tried it",
      "Who you were with",
      "How you felt about trying it"
    ]
  },
  {
    instruction: "Describe a family celebration you remember",
    prompts: [
      "What the celebration was for",
      "When and where it took place",
      "Who was there",
      "Why it was memorable"
    ]
  },
  {
    instruction: "Describe an interesting conversation you had",
    prompts: [
      "Who you spoke with",
      "What you spoke about",
      "When and where the conversation took place",
      "Why it was interesting"
    ]
  },
  {
    instruction: "Describe a movie or TV show you enjoyed watching",
    prompts: [
      "What it was about",
      "When you watched it",
      "Who you watched it with",
      "Why you enjoyed it"
    ]
  },
  {
    instruction: "Describe a holiday destination you would recommend",
    prompts: [
      "Where it is",
      "What people can do there",
      "When is the best time to visit",
      "Why you would recommend it"
    ]
  },
  {
    instruction: "Describe a change that improved your life",
    prompts: [
      "What the change was",
      "When it happened",
      "How it happened",
      "Why it improved your life"
    ]
  },
  {
    instruction: "Describe a language other than English that you would like to learn",
    prompts: [
      "What language it is",
      "How you would learn it",
      "Why you want to learn it",
      "How it would help you"
    ]
  },
  {
    instruction: "Describe a special photograph you have",
    prompts: [
      "What is in the photograph",
      "When it was taken",
      "Where you keep it",
      "Why it is special to you"
    ]
  },
  {
    instruction: "Describe a historical building you have visited",
    prompts: [
      "Where it is located",
      "When you visited it",
      "What it looks like",
      "Why you found it interesting"
    ]
  },
  {
    instruction: "Describe an important river or lake in your country",
    prompts: [
      "Where it is",
      "How people use it",
      "What wildlife lives there",
      "Why it is important"
    ]
  },
  {
    instruction: "Describe a time when you were very busy",
    prompts: [
      "When this was",
      "What you were doing",
      "Why you were so busy",
      "How you managed the situation"
    ]
  },
  {
    instruction: "Describe a piece of advice that someone gave you",
    prompts: [
      "What the advice was",
      "Who gave you the advice",
      "Why they gave you the advice",
      "How this advice helped you"
    ]
  },
  {
    instruction: "Describe a musical instrument you would like to play",
    prompts: [
      "What the instrument is",
      "How you would learn to play it",
      "Why you want to play it",
      "How it would make you feel"
    ]
  },
  {
    instruction: "Describe an item you bought but rarely use",
    prompts: [
      "What the item is",
      "When and where you bought it",
      "Why you bought it",
      "Why you rarely use it"
    ]
  },
  // 以下是再增加的25道Part 2话题卡片
  {
    instruction: "Describe a sporting event you have attended",
    prompts: [
      "What the event was",
      "When and where it was held",
      "Who you went with",
      "How you felt about the experience"
    ]
  },
  {
    instruction: "Describe a challenging experience in your life",
    prompts: [
      "What the experience was",
      "When it happened",
      "Why it was challenging",
      "How you overcame the challenge"
    ]
  },
  {
    instruction: "Describe a science subject that interests you",
    prompts: [
      "What the subject is",
      "When you first became interested in it",
      "How you learn about it",
      "Why it interests you"
    ]
  },
  {
    instruction: "Describe a famous person you admire",
    prompts: [
      "Who this person is",
      "What they have achieved",
      "How you know about them",
      "Why you admire them"
    ]
  },
  {
    instruction: "Describe a situation when you had to be polite",
    prompts: [
      "When this happened",
      "Where it happened",
      "Why you had to be polite",
      "How you felt about it"
    ]
  },
  {
    instruction: "Describe a neighborhood or area you enjoy spending time in",
    prompts: [
      "Where it is",
      "What it looks like",
      "What you do there",
      "Why you enjoy spending time there"
    ]
  },
  {
    instruction: "Describe a time when you had to wait for something special",
    prompts: [
      "What you were waiting for",
      "How long you had to wait",
      "Why you had to wait",
      "How you felt while waiting"
    ]
  },
  {
    instruction: "Describe a concert or live performance you have attended",
    prompts: [
      "What kind of performance it was",
      "When and where you saw it",
      "Who performed",
      "How you felt about the performance"
    ]
  },
  {
    instruction: "Describe a time when you solved a problem in a creative way",
    prompts: [
      "What the problem was",
      "How you solved it",
      "Why your solution was creative",
      "What the result was"
    ]
  },
  {
    instruction: "Describe a prize you would like to win",
    prompts: [
      "What the prize is",
      "How you could win it",
      "Why you want to win it",
      "How you would feel if you won it"
    ]
  },
  {
    instruction: "Describe a park or garden you like to visit",
    prompts: [
      "Where it is",
      "What it looks like",
      "What you do there",
      "Why you like visiting it"
    ]
  },
  {
    instruction: "Describe a time when you received excellent customer service",
    prompts: [
      "When and where this happened",
      "What service you received",
      "Why you thought it was excellent",
      "How you felt about it"
    ]
  },
  {
    instruction: "Describe a time when you had to learn something quickly",
    prompts: [
      "What you had to learn",
      "Why you had to learn it quickly",
      "How you learned it",
      "How successful you were"
    ]
  },
  {
    instruction: "Describe a competition or contest you participated in",
    prompts: [
      "What the competition was",
      "When and where it took place",
      "How you prepared for it",
      "What the results were"
    ]
  },
  {
    instruction: "Describe a tradition in your family",
    prompts: [
      "What the tradition is",
      "When and how it is observed",
      "Who participates in it",
      "Why this tradition is important to your family"
    ]
  },
  {
    instruction: "Describe a skill that took you a long time to learn",
    prompts: [
      "What the skill is",
      "How you learned it",
      "Why it took a long time",
      "How you feel about it now"
    ]
  },
  {
    instruction: "Describe a dream house you would like to live in",
    prompts: [
      "Where it would be located",
      "What it would look like",
      "What special features it would have",
      "Why you would want to live there"
    ]
  },
  {
    instruction: "Describe a childhood toy you remember",
    prompts: [
      "What the toy was",
      "Who gave it to you or how you got it",
      "How you played with it",
      "Why you remember it"
    ]
  },
  {
    instruction: "Describe a public transportation system you have used",
    prompts: [
      "What type of transportation it was",
      "Where and when you used it",
      "How often you used it",
      "What you thought about it"
    ]
  },
  {
    instruction: "Describe an important choice you had to make",
    prompts: [
      "What the choice was",
      "When you had to make it",
      "How you made your decision",
      "Whether you were satisfied with your choice"
    ]
  },
  {
    instruction: "Describe a foreign country you would like to visit",
    prompts: [
      "Which country it is",
      "What you know about this country",
      "Why you want to visit it",
      "What you would do there"
    ]
  },
  {
    instruction: "Describe a time when you helped a child",
    prompts: [
      "Who the child was",
      "When and where you helped them",
      "How you helped them",
      "How you felt about it"
    ]
  },
  {
    instruction: "Describe a place where you go to relax",
    prompts: [
      "Where this place is",
      "How often you go there",
      "What you do there",
      "Why you find it relaxing"
    ]
  },
  {
    instruction: "Describe a time when you were late",
    prompts: [
      "When this happened",
      "Why you were late",
      "How you felt about it",
      "What happened as a result"
    ]
  },
];

// 添加Part 3预设问题数据
export const PART3_QUESTIONS = [
  "Do you think technology has changed the way people communicate with each other?",
  "How has the internet affected the way people work in your country?",
  "Do you think social media is having a positive or negative effect on young people?",
  "In what ways has education changed in recent years in your country?",
  "How important do you think it is for people to have hobbies?",
  "What role do you think art plays in society?",
  "Why do some people prefer to live in the countryside rather than in cities?",
  "How has transportation changed in your country over the last few decades?",
  "What skills do you think are most important for success in today's job market?",
  "Do you think traditional customs are important in the modern world?",
  "How do you think climate change will affect your country in the future?",
  "What can governments do to help protect the environment?",
  "Why do you think some people are more interested in international news than others?",
  "Do you think it's better to travel in a group or independently?",
  "How do you think tourism affects local communities?",
  "What do you think are the main causes of stress in modern society?",
  "How do people in your country typically relax after a long day at work?",
  "What kinds of food are popular in your country, and why?",
  "Do you think people's eating habits are better or worse than they were in the past?",
  "How do you think family life has changed in recent decades?",
  // 以下是新增的30道题目
  "Do you think online learning is as effective as traditional classroom learning?",
  "What effects does advertising have on the way people shop?",
  "How important is it for children to learn about nature?",
  "Do you think people read fewer books nowadays than in the past?",
  "In what ways has technology changed the music industry?",
  "What factors influence people's choice of career?",
  "Do you think public transportation should be free in cities?",
  "How has the way people make friends changed in recent years?",
  "What role do grandparents play in families in your country?",
  "Do you think international sporting events bring countries together?",
  "How do people in your country feel about learning foreign languages?",
  "What impact do you think artificial intelligence will have on employment?",
  "Do you think young people today face more pressure than previous generations?",
  "How important are outdoor activities for children's development?",
  "What are the advantages and disadvantages of working from home?",
  "Do you think people should be encouraged to use less plastic?",
  "How has smartphone technology changed daily life?",
  "What qualities make someone a good leader?",
  "Do you think cities are becoming better places to live?",
  "How do fashion trends influence people's buying habits?",
  "What role does music play in your culture?",
  "Do you think travel is necessary for understanding different cultures?",
  "How are elderly people cared for in your society?",
  "What impact has online shopping had on traditional retail?",
  "Do you think schools should teach financial literacy to students?",
  "How important is work-life balance in modern society?",
  "What factors contribute to the success or failure of small businesses?",
  "Do you think children should be given more freedom nowadays?",
  "How has social media affected political awareness among young people?",
  "What measures can individuals take to reduce their environmental impact?"
];

// 添加Part 3追问问题数据 - 通用追问
export const PART3_FOLLOWUP_QUESTIONS = [
  // 延伸类追问
  "Could you expand on why you think that?",
  "What are some examples that support your view?",
  "How does this compare to the situation in other countries?",
  "What might be some alternative perspectives on this issue?",
  "How might this change in the future?",
  
  // 深入类追问
  "What do you think are the main factors that have caused this?",
  "What might be some of the consequences of this trend?",
  "Do you think this affects different generations in different ways?",
  "How does this impact society as a whole?",
  "What role should the government play in addressing this issue?",
  
  // 应用类追问
  "How has this affected your personal experience?",
  "What solutions might there be to the problems you've mentioned?",
  "How might education help address these challenges?",
  "What can individuals do to make a difference in this situation?",
  "How might technology change this in the coming years?"
];

// 添加每个初始问题专门的追问问题（每个问题3个专门追问）
export const PART3_SPECIFIC_FOLLOWUPS = {
  // 1. 技术与沟通
  "Do you think technology has changed the way people communicate with each other?": [
    "Do you think people communicate more superficially now because of technology?",
    "How has video calling technology affected relationships between family members living far apart?",
    "Do you believe the benefits of instant messaging outweigh the drawbacks?"
  ],
  
  // 2. 互联网与工作
  "How has the internet affected the way people work in your country?": [
    "Has remote work become more common in your country's traditional industries?",
    "In what ways has online collaboration changed workplace relationships?",
    "Do you think the internet has created more job opportunities or eliminated them?"
  ],
  
  // 3. 社交媒体与年轻人
  "Do you think social media is having a positive or negative effect on young people?": [
    "How has social media affected young people's mental health in your opinion?",
    "Do you think social media helps or hinders young people's social development?",
    "What could be done to minimize the negative aspects of social media for youth?"
  ],
  
  // 4. 教育变化
  "In what ways has education changed in recent years in your country?": [
    "Has technology improved the quality of education in your country?",
    "How have teaching methods evolved in the past decade?",
    "Do you think these changes in education have prepared students better for their futures?"
  ],
  
  // 5. 爱好的重要性
  "How important do you think it is for people to have hobbies?": [
    "What kinds of hobbies do you think are most beneficial for reducing stress?",
    "Do you think employers should consider candidates' hobbies during hiring?",
    "How might hobbies contribute to a person's professional development?"
  ],
  
  // 6. 艺术在社会中的作用
  "What role do you think art plays in society?": [
    "Do you think government funding for the arts is justified?",
    "How does art reflect or influence social values in your culture?",
    "In what ways can art education benefit children's development?"
  ],
  
  // 7. 城市与乡村生活
  "Why do some people prefer to live in the countryside rather than in cities?": [
    "Do you think the trend of moving to rural areas will continue in the future?",
    "How has technology made rural living more feasible for city workers?",
    "What could cities do to provide the benefits people seek in rural areas?"
  ],
  
  // 8. 交通变化
  "How has transportation changed in your country over the last few decades?": [
    "Has public transportation improved or deteriorated in your region?",
    "What impact have transportation changes had on the environment?",
    "How do you think transportation will evolve in the next twenty years?"
  ],
  
  // 9. 职场技能
  "What skills do you think are most important for success in today's job market?": [
    "How important is emotional intelligence compared to technical skills?",
    "Do you think universities effectively teach the skills needed in today's workplace?",
    "Which skills do you think will become more valuable in the next decade?"
  ],
  
  // 10. 传统习俗
  "Do you think traditional customs are important in the modern world?": [
    "Which traditions do you think are most at risk of disappearing?",
    "How can societies balance modernization with preserving traditions?",
    "Do you think younger generations value traditions differently than older generations?"
  ],
  
  // 11. 气候变化影响
  "How do you think climate change will affect your country in the future?": [
    "Which industries in your country will be most affected by climate change?",
    "What adaptations might be necessary in urban planning due to climate change?",
    "How is public awareness about climate change evolving in your country?"
  ],
  
  // 12. 环保政府措施
  "What can governments do to help protect the environment?": [
    "Do you think economic incentives or regulations are more effective for environmental protection?",
    "Should developing countries have different environmental responsibilities than developed ones?",
    "How can governments encourage businesses to adopt sustainable practices?"
  ],
  
  // 13. 国际新闻兴趣
  "Why do you think some people are more interested in international news than others?": [
    "How does interest in international news relate to a person's education level?",
    "Do social media platforms improve or reduce people's understanding of international events?",
    "Has interest in global news increased in your country in recent years?"
  ],
  
  // 14. 旅行方式选择
  "Do you think it's better to travel in a group or independently?": [
    "How does age affect people's preferences for group or independent travel?",
    "What skills can people develop through independent travel?",
    "Do you think travel apps have made independent travel easier or more challenging?"
  ],
  
  // 15. 旅游对当地社区的影响
  "How do you think tourism affects local communities?": [
    "What can tourists do to minimize negative impacts on local communities?",
    "How has the growth of home-sharing platforms affected local housing markets?",
    "Should there be limitations on tourism in environmentally sensitive areas?"
  ],
  
  // 16. 现代社会压力
  "What do you think are the main causes of stress in modern society?": [
    "Do you think work-related stress has increased over the past decade?",
    "How do social expectations contribute to people's stress levels?",
    "What stress management techniques do you think are most effective?"
  ],
  
  // 17. 放松方式
  "How do people in your country typically relax after a long day at work?": [
    "Do you think digital entertainment has replaced more traditional relaxation activities?",
    "How do relaxation habits differ between generations in your country?",
    "Do you think people in your country achieve a good work-life balance?"
  ],
  
  // 18. 食物文化
  "What kinds of food are popular in your country, and why?": [
    "How has international cuisine influenced eating habits in your country?",
    "Do you think traditional dishes are being preserved or forgotten?",
    "How has the concept of convenience food changed eating patterns?"
  ],
  
  // 19. 饮食习惯变化
  "Do you think people's eating habits are better or worse than they were in the past?": [
    "How has nutritional awareness affected people's food choices?",
    "What role does advertising play in influencing eating habits?",
    "Do you think the increase in eating out has had a positive or negative effect?"
  ],
  
  // 20. 家庭生活变化
  "How do you think family life has changed in recent decades?": [
    "How has technology affected communication within families?",
    "Do you think the changing roles of men and women have improved family life?",
    "What challenges do modern families face that previous generations didn't?"
  ],
  
  // 21. 在线学习
  "Do you think online learning is as effective as traditional classroom learning?": [
    "What types of subjects or skills are better learned online versus in a classroom?",
    "How does online learning affect students' social development?",
    "Do you think online learning will eventually replace traditional education methods?"
  ],
  
  // 22. 广告对购物的影响
  "What effects does advertising have on the way people shop?": [
    "How do you think social media advertising differs from traditional forms of advertising?",
    "Do you think people are becoming more resistant to advertising techniques?",
    "Should there be more regulations on advertising to certain groups, like children?"
  ],
  
  // 23. 儿童与自然
  "How important is it for children to learn about nature?": [
    "What are the consequences if children spend too little time in natural environments?",
    "How can urban families ensure their children connect with nature?",
    "Do you think schools should include more outdoor education in their curriculum?"
  ],
  
  // 24. 阅读习惯变化
  "Do you think people read fewer books nowadays than in the past?": [
    "How has digital reading changed people's reading habits?",
    "What could be done to encourage more people to read books?",
    "Do you think reading different types of content online is comparable to reading books?"
  ],
  
  // 25. 技术对音乐产业的影响
  "In what ways has technology changed the music industry?": [
    "How has streaming technology affected musicians' ability to earn a living?",
    "Do you think music quality has improved or declined with technological advances?",
    "How has technology changed the way people discover new music?"
  ],
  
  // 26. 职业选择的因素
  "What factors influence people's choice of career?": [
    "Do you think financial considerations should be the primary factor in choosing a career?",
    "How much influence should parents have on their children's career choices?",
    "Has the concept of a 'job for life' disappeared in modern society?"
  ],
  
  // 27. 免费公共交通
  "Do you think public transportation should be free in cities?": [
    "How could cities finance free public transportation?",
    "What would be the environmental impact of making public transport free?",
    "Would free transportation change where people choose to live and work?"
  ],
  
  // 28. 交友方式变化
  "How has the way people make friends changed in recent years?": [
    "Do you think online friendships are as meaningful as those formed in person?",
    "How do age differences affect the way people approach making new friends?",
    "What role do shared interests play in forming friendships today compared to the past?"
  ],
  
  // 29. 祖父母的作用
  "What role do grandparents play in families in your country?": [
    "How has the role of grandparents in childcare changed over the generations?",
    "What can children learn from their grandparents that they might not learn from their parents?",
    "How do you think geographic distance affects relationships between grandparents and grandchildren?"
  ],
  
  // 30. 国际体育赛事
  "Do you think international sporting events bring countries together?": [
    "Are there any negative aspects to international sporting competitions?",
    "How do international sports events affect national identity?",
    "Should politics be kept separate from international sporting events?"
  ],
  
  // 31. 学习外语的态度
  "How do people in your country feel about learning foreign languages?": [
    "Which foreign languages are most popular to learn in your country, and why?",
    "Do you think there's a relationship between language learning and cultural appreciation?",
    "How might language learning requirements in education change in the future?"
  ],
  
  // 32. 人工智能对就业的影响
  "What impact do you think artificial intelligence will have on employment?": [
    "Which jobs do you think are most vulnerable to automation in the coming decade?",
    "How should education systems adapt to prepare students for an AI-driven job market?",
    "Could AI create more jobs than it eliminates, and if so, in what fields?"
  ],
  
  // 33. 年轻人面临的压力
  "Do you think young people today face more pressure than previous generations?": [
    "How has social media contributed to the pressures young people face?",
    "What role should schools play in helping students manage pressure?",
    "Do you think pressure on young people varies significantly between different cultures?"
  ],
  
  // 34. 户外活动对儿童发展的重要性
  "How important are outdoor activities for children's development?": [
    "What specific developmental benefits do outdoor activities provide that indoor activities don't?",
    "How has children's participation in outdoor activities changed over the past few decades?",
    "What can urban planners do to encourage more outdoor activity among children?"
  ],
  
  // 35. 在家工作的利弊
  "What are the advantages and disadvantages of working from home?": [
    "How does working from home affect team collaboration and company culture?",
    "Do you think working from home is more suitable for certain personality types?",
    "How might homes and residential areas change if more people work remotely long-term?"
  ],
  
  // 36. 减少塑料使用
  "Do you think people should be encouraged to use less plastic?": [
    "What alternatives to plastic packaging are most promising?",
    "How effective are bans on single-use plastics compared to other approaches?",
    "What responsibility do manufacturers have in reducing plastic waste?"
  ],
  
  // 37. 智能手机技术对日常生活的改变
  "How has smartphone technology changed daily life?": [
    "Do you think smartphones have made people more or less productive?",
    "How has constant connectivity affected people's mental health?",
    "In what ways do different generations use smartphones differently?"
  ],
  
  // 38. 好领导的品质
  "What qualities make someone a good leader?": [
    "Do you think leadership qualities are mostly innate or can they be developed?",
    "How have expectations of leadership changed in recent years?",
    "Do you think different cultural contexts require different leadership styles?"
  ],
  
  // 39. 城市宜居性变化
  "Do you think cities are becoming better places to live?": [
    "What aspects of urban planning most affect residents' quality of life?",
    "How are cities addressing environmental challenges?",
    "Do you think there's an ideal size for a city in terms of livability?"
  ],
  
  // 40. 时尚潮流对购买习惯的影响
  "How do fashion trends influence people's buying habits?": [
    "Do you think fast fashion has changed people's attitudes toward clothing?",
    "How has social media affected the spread of fashion trends?",
    "What factors determine whether someone follows fashion trends or not?"
  ],
  
  // 41. 音乐在文化中的角色
  "What role does music play in your culture?": [
    "How has traditional music in your culture evolved with modern influences?",
    "Do certain types of music bring people together in your community?",
    "How is music education valued in your country's school system?"
  ],
  
  // 42. 旅行与文化理解
  "Do you think travel is necessary for understanding different cultures?": [
    "Can books, films, or virtual experiences provide similar cultural understanding as travel?",
    "How does the length of time spent in a place affect cultural understanding?",
    "Do you think tourism can sometimes lead to misunderstandings about cultures?"
  ],
  
  // 43. 老年人照护
  "How are elderly people cared for in your society?": [
    "How has the approach to elder care changed over time in your country?",
    "What advantages and disadvantages do you see in different elder care systems?",
    "How might technological advances change elder care in the future?"
  ],
  
  // 44. 网购对传统零售的影响
  "What impact has online shopping had on traditional retail?": [
    "Do you think traditional stores can offer anything that online shopping cannot?",
    "How have shopping malls and high streets adapted to compete with online retailers?",
    "What might the balance between online and in-person shopping look like in the future?"
  ],
  
  // 45. 财务素养教育
  "Do you think schools should teach financial literacy to students?": [
    "At what age do you think financial education should begin?",
    "Whose responsibility is it to ensure young people understand money management?",
    "What specific financial skills do you think are most important for young people to learn?"
  ],
  
  // 46. 工作与生活平衡
  "How important is work-life balance in modern society?": [
    "Do you think attitudes toward work-life balance differ across generations?",
    "What role should employers play in promoting healthy work-life balance?",
    "How do cultural differences affect expectations about work hours and leisure time?"
  ],
  
  // 47. 小企业成功或失败的因素
  "What factors contribute to the success or failure of small businesses?": [
    "How important is location for different types of small businesses?",
    "Do you think personality traits of business owners affect their chances of success?",
    "How has the internet changed opportunities for small businesses?"
  ],
  
  // 48. 儿童自由度
  "Do you think children should be given more freedom nowadays?": [
    "How does the freedom given to children affect their development of responsibility?",
    "What factors influence how much freedom parents give their children?",
    "Do you think there are cultural differences in attitudes toward children's freedom?"
  ],
  
  // 49. 社交媒体对政治意识的影响
  "How has social media affected political awareness among young people?": [
    "Do you think social media provides a balanced view of political issues?",
    "How has online political engagement translated to real-world political action?",
    "What responsibility do social media platforms have in monitoring political content?"
  ],
  
  // 50. 个人环保措施
  "What measures can individuals take to reduce their environmental impact?": [
    "Which individual actions do you think have the greatest environmental benefit?",
    "How important is individual action compared to governmental or corporate policy?",
    "What motivates people to make environmentally friendly choices in their daily lives?"
  ]
};

// 添加听题时间常量
export const LISTENING_TIME = 15; // 15秒听题时间

// 共享工具函数

// 文本转语音函数
export const speakText = (text) => {
  if ('speechSynthesis' in window) {
    try {
      // 取消当前正在播放的语音
      window.speechSynthesis.cancel();
      
      // 创建语音合成请求
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'en-US'; // 设置英语发音
      utterance.rate = 0.9; // 语速稍慢一些，更清晰
      
      // 为iPad/iOS添加特殊处理
      // iOS Safari需要在用户交互中触发语音
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
      
      if (isIOS) {
        // 在iOS上，添加错误处理和重试机制
        utterance.onerror = (event) => {
          console.warn('iOS语音播放错误:', event.error);
          // 如果是因为未授权，提示用户点击"重听"按钮
          if (event.error === 'not-allowed' || event.error === 'interrupted') {
            console.log('iOS需要用户手势触发语音，请点击"重听"按钮');
          }
        };
        
        // iOS上需要短暂延迟以确保语音队列准备好
        setTimeout(() => {
          window.speechSynthesis.speak(utterance);
        }, 100);
      } else {
        // 非iOS设备直接播放
        window.speechSynthesis.speak(utterance);
      }
      
      console.log('语音播放已触发:', text.substring(0, 50) + '...');
    } catch (error) {
      console.error('语音播放失败:', error);
    }
  } else {
    console.error('浏览器不支持语音合成API');
  }
};

// API请求函数
export const getAIFollowUpQuestion = async (initialQuestion, studentAnswer) => {
  console.log('正在调用API获取追问问题...');
  
  // 设计Prompt
  const prompt = `你是一位经验丰富的雅思口语考官，正在进行Part 3的深入讨论环节。请根据以下信息生成一个针对性的追问问题：

原始问题: ${initialQuestion}
考生回答: ${studentAnswer}

请生成一个自然、有深度的追问问题，要求：
1. 直接基于考生回答中的某个观点或论点进行提问
2. 鼓励考生更深入地解释、分析或举例
3. 问题应简洁明了，不超过20个单词
4. 不要重复原问题中已涉及的内容
5. 不要加入任何解释或评论，只输出追问问题本身
6. 确保问题开放性，避免是/否问题

输出格式：仅输出追问问题，不要有其他内容。`;

  try {
    const response = await fetch('https://api.deepseek.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer sk-eadkgiothgyrfrjsucchqhvuhqhsyynwucfyxevozoraiksy'
      },
      body: JSON.stringify({
        model: 'Qwen/QwQ-32B',
        messages: [
          {
            role: 'user',
            content: prompt
          }
        ],
        temperature: 0.7,
        max_tokens: 200
      })
    });

    const data = await response.json();
    
    // 检查响应是否成功
    if (data.choices && data.choices.length > 0 && data.choices[0].message) {
      const followUpQuestion = data.choices[0].message.content.trim();
      console.log('API返回的追问问题:', followUpQuestion);
      return followUpQuestion;
    } else {
      console.error('API响应格式不正确:', data);
      return null;
    }
  } catch (error) {
    console.error('API调用失败:', error);
    return null;
  }
};

// 主容器组件
const TrainingContainer = ({ 
  deadline, 
  username, 
  purpose, 
  children, 
  selectedPart, 
  setSelectedPart,
  mode,
  isLoggedIn,
  sessionId
}) => {
  const { t, language } = useLanguage();
  const [daysLeft, setDaysLeft] = useState(0);
  const [examDate, setExamDate] = useState('');
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const [showEndModal, setShowEndModal] = useState(false);
  const [showScoreReport, setShowScoreReport] = useState(false);
  // Add state for messages to download
  const [currentMessages, setCurrentMessages] = useState([]);
  // Add state for dialogue history
  const [showDialogueHistory, setShowDialogueHistory] = useState(false);
  const [dialogueHistory, setDialogueHistory] = useState([]);
  // Add state for detailed round view
  const [selectedRound, setSelectedRound] = useState(null);
  const [showRoundDetail, setShowRoundDetail] = useState(false);

  // Add state for optimization modal
  const [showOptimizationModal, setShowOptimizationModal] = useState(false);

  // Add state for current round
  const [currentRound, setCurrentRound] = useState(null);

  // 使用useRef来跟踪当前轮次
  const currentRoundRef = useRef(null);
  
  // 获取页面标题
  const getPageTitle = () => {
    if (mode === 'mockTest') {
      return t('welcome_to_training') + ' - ' + t('mock_exam');
    } else if (mode === 'simulation') {
      return t('welcome_to_training') + ' - ' + t('simulation_training');
    } else {
      return t('welcome_to_training');
    }
  };

  // 处理关闭完成弹窗
  const handleCloseCompletionModal = () => {
    setShowCompletionModal(false);
    
    // 添加触发重置事件的代码
    const completionClosedEvent = new CustomEvent('completionModalClosed', {
      detail: { part: selectedPart }
    });
    window.dispatchEvent(completionClosedEvent);
    console.log("关闭完成弹窗，触发重置事件:", selectedPart);
  };

  // 处理重复本题
  const handleRepeatCurrentTopic = () => {
    setShowCompletionModal(false);
    // This will be handled by the child component through the callback
  };

  // 处理开始新一轮
  const handleStartNewRound = () => {
    setShowCompletionModal(false);
    // This will be handled by the child component through the callback
  };

  // 修改处理查看历史记录的函数
  const handleViewHistory = () => {
    // 不关闭选项弹窗，在上面显示历史记录弹窗
    loadDialogueHistory();
    setShowDialogueHistory(true);
  };

  // 检查并清理过期记录
  const cleanupExpiredRecords = useCallback(() => {
    try {
      // 设置过期时间为3天（259200000毫秒）
      const EXPIRY_MS = 3 * 24 * 60 * 60 * 1000;
      const now = new Date().getTime();
      
      // 如果是游客模式，检查会话创建时间
      if (!isLoggedIn) {
        const guestCreatedStr = localStorage.getItem('talktastic_guest_created');
        if (guestCreatedStr) {
          const created = new Date(guestCreatedStr).getTime();
          if (now - created > EXPIRY_MS) {
            // 会话已过期，清除游客数据
            console.log('游客会话已过期，清除历史记录');
            localStorage.removeItem('talktastic_guest_id');
            localStorage.removeItem('talktastic_guest_created');
            
            // 清除该游客的历史记录
            const allHistoryStr = localStorage.getItem('talktastic_histories');
            if (allHistoryStr) {
              const allHistory = JSON.parse(allHistoryStr);
              if (allHistory[sessionId]) {
                delete allHistory[sessionId];
                localStorage.setItem('talktastic_histories', JSON.stringify(allHistory));
              }
            }
            return;
          }
        }
      }
      
      // 检查所有历史记录
      const allHistoryStr = localStorage.getItem('talktastic_histories');
      if (allHistoryStr) {
        const allHistory = JSON.parse(allHistoryStr);
        let hasChanges = false;
        
        // 遍历所有用户的历史记录
        Object.keys(allHistory).forEach(userId => {
          // 跳过当前用户的记录
          if (userId === sessionId) return;
          
          // 检查游客会话是否过期
          if (userId.startsWith('guest_')) {
            const guestData = allHistory[userId];
            if (guestData.created) {
              const created = new Date(guestData.created).getTime();
              if (now - created > EXPIRY_MS) {
                // 删除过期记录
                delete allHistory[userId];
                hasChanges = true;
              }
            }
          }
        });
        
        if (hasChanges) {
          localStorage.setItem('talktastic_histories', JSON.stringify(allHistory));
        }
      }
    } catch (error) {
      console.error('清理过期记录失败:', error);
    }
  }, [isLoggedIn, sessionId]);

  // 组件加载时，检查并清理过期记录
  useEffect(() => {
    if (sessionId) {
      cleanupExpiredRecords();
    }
  }, [sessionId, cleanupExpiredRecords]);

  // 加载历史记录的函数
  const loadDialogueHistory = () => {
    // 从localStorage加载历史记录
    try {
      // 检查新的历史记录存储结构
      const allHistoryStr = localStorage.getItem('talktastic_histories');
      if (allHistoryStr && sessionId) {
        const allHistory = JSON.parse(allHistoryStr);
        if (allHistory[sessionId] && allHistory[sessionId].records) {
          setDialogueHistory(allHistory[sessionId].records);
          return;
        }
      }
      
      // 兼容旧版本 - 将旧格式的历史记录迁移到新格式
      const oldHistoryStr = localStorage.getItem('dialogueHistory');
      if (oldHistoryStr && sessionId) {
        try {
          const oldHistory = JSON.parse(oldHistoryStr);
          if (Array.isArray(oldHistory) && oldHistory.length > 0) {
            // 迁移旧历史记录到新格式
            saveHistoryToNewFormat(oldHistory);
            setDialogueHistory(oldHistory);
            // 迁移完成后可以清除旧格式数据
            localStorage.removeItem('dialogueHistory');
            return;
          }
        } catch (e) {
          console.error('解析旧历史记录失败:', e);
        }
      }
      
      // 如果没有找到历史记录，设置为空数组
      setDialogueHistory([]);
    } catch (error) {
      console.error('加载历史记录失败:', error);
      setDialogueHistory([]);
    }
  };

  // 迁移旧格式历史记录到新格式
  const saveHistoryToNewFormat = (history) => {
    try {
      const allHistoryStr = localStorage.getItem('talktastic_histories');
      let allHistory = allHistoryStr ? JSON.parse(allHistoryStr) : {};
      
      // 创建或更新当前用户的历史记录
      allHistory[sessionId] = {
        created: new Date().toISOString(),
        records: history
      };
      
      localStorage.setItem('talktastic_histories', JSON.stringify(allHistory));
    } catch (error) {
      console.error('迁移历史记录失败:', error);
    }
  };

  // 保存当前对话
  const saveCurrentDialogue = () => {
    if (currentMessages.length === 0 || !sessionId) {
      console.log('没有可保存的对话或会话ID缺失');
      return; // 如果没有消息或会话ID，不保存
    }
    
    // 加载现有历史记录
    let history = [];
    let userHistory = {};
    try {
      // 先尝试读取新格式的历史记录
      const allHistoryStr = localStorage.getItem('talktastic_histories');
      let allHistory = allHistoryStr ? JSON.parse(allHistoryStr) : {};
      
      if (allHistory[sessionId]) {
        userHistory = allHistory[sessionId];
        history = userHistory.records || [];
      } else {
        userHistory = {
          created: new Date().toISOString(),
          records: []
        };
        allHistory[sessionId] = userHistory;
      }
    } catch (error) {
      console.error('加载历史记录失败:', error);
      userHistory = {
        created: new Date().toISOString(),
        records: []
      };
    }
      
      // 创建新的对话记录
    const now = new Date();
    const dateStr = now.toLocaleDateString();
    const timeStr = now.toLocaleTimeString();
    
    // 获取最大ID
    let maxId = 0;
    if (history.length > 0) {
      maxId = Math.max(...history.map(item => item.id));
    }
    
    const newRound = {
      id: maxId + 1,
        date: dateStr,
        time: timeStr,
        part: selectedPart,
        messages: currentMessages
      };
      
    // 更新当前轮次，用于生成报告
    setCurrentRound(newRound);
    // 同步更新ref
    currentRoundRef.current = newRound;
    
    // 添加到历史记录
    history.push(newRound);
    userHistory.records = history;
    
    // 保存到新格式的历史记录中
    try {
      const allHistoryStr = localStorage.getItem('talktastic_histories');
      let allHistory = allHistoryStr ? JSON.parse(allHistoryStr) : {};
      allHistory[sessionId] = userHistory;
      
      localStorage.setItem('talktastic_histories', JSON.stringify(allHistory));
      console.log('对话保存成功');
    } catch (error) {
      console.error('保存对话失败:', error);
    }
    
    // 更新当前历史记录状态
    setDialogueHistory(history);
  };

  // 修改处理关闭历史记录的函数
  const handleCloseHistory = () => {
    setShowDialogueHistory(false);
  };

  // 添加导出历史记录的函数
  const handleExportHistory = (date) => {
    try {
      // 筛选指定日期和当前模块的记录
      const dateRecords = dialogueHistory.filter(
        item => item.date === date && item.part === selectedPart
      );
      
      if (dateRecords.length === 0) {
        alert(language === 'en' ? 'No conversation records found for this date' : '该日期没有对话记录');
        return;
      }
      
      // 生成导出内容 - 根据当前界面语言选择输出语言
      let exportContent = '';
      
      if (language === 'en') {
        exportContent = `===== Part ${selectedPart.replace('part', '')} Speaking Practice Records - ${date} =====\n\n`;
        
        dateRecords.forEach((record, index) => {
          exportContent += `==== Round ${index + 1} (${record.time}) ====\n\n`;
          
          record.messages.forEach(message => {
            const sender = message.type === 'mentor' ? 'Assistant' : (username || 'User');
            const time = message.time || '';
            exportContent += `${sender} [${time}]:\n${message.content}\n\n`;
          });
          
          exportContent += '----------\n\n';
        });
        
        // 添加日期和会话信息
        exportContent += `\nExport time: ${new Date().toLocaleString('en-US')}\n`;
        if (!isLoggedIn) {
          exportContent += `Note: You are in guest mode. Your records will be automatically deleted after 3 days.\n`;
        }
      } else {
        exportContent = `===== Part ${selectedPart.replace('part', '')} 口语练习对话记录 - ${date} =====\n\n`;
      
      dateRecords.forEach((record, index) => {
        exportContent += `==== 轮次 ${index + 1} (${record.time}) ====\n\n`;
        
        record.messages.forEach(message => {
          const sender = message.type === 'mentor' ? '助手' : (username || '用户');
          const time = message.time || '';
          exportContent += `${sender} [${time}]:\n${message.content}\n\n`;
        });
        
        exportContent += '----------\n\n';
      });
      
        // 添加日期和会话信息
        exportContent += `\n导出时间: ${new Date().toLocaleString('zh-CN')}\n`;
        if (!isLoggedIn) {
          exportContent += `注意：您正在使用游客模式。记录将在3天后自动删除。\n`;
        }
      }
      
      // 创建文本文件并下载
      const blob = new Blob([exportContent], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      
      // 根据界面语言设置文件名
      if (language === 'en') {
        a.download = `Part${selectedPart.replace('part', '')}_Speaking_Records-${date}.txt`;
      } else {
      a.download = `Part${selectedPart.replace('part', '')}_口语练习记录-${date}.txt`;
      }
      
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(language === 'en' ? 'Failed to export history:' : '导出历史记录失败:', error);
      alert(language === 'en' ? 'Export failed, please try again' : '导出失败，请重试');
    }
  };

  // 查看提分报告的函数
  const handleViewReport = async () => {
    console.log('查看提分报告');
    
    // 检查用户是否已登录
    const storedUser = localStorage.getItem('talktastic_user');
    const isUserLoggedIn = storedUser && JSON.parse(storedUser)?.isLoggedIn;
    
    if (isUserLoggedIn) {
      // 已登录，先关闭结束模态框，然后显示提分报告
      setShowEndModal(false);
      console.log('用户已登录，显示提分报告');
      setShowScoreReport(true);
    } else {
      // 未登录，直接跳转到登录页面，不关闭模态框也不显示提分报告
      console.log('用户未登录，跳转到登录页面');
      window.location.href = '/login';
    }
  };
  
  // 修改处理关闭提分报告的函数
  const handleCloseReport = () => {
    // 关闭报告弹窗
    setShowScoreReport(false);
    
    // 触发重置事件，确保用户可以继续练习
    const resetEvent = new CustomEvent('resetTrainingState', {
      detail: { part: selectedPart }
    });
    window.dispatchEvent(resetEvent);
    
    // 触发完成弹窗关闭事件，确保所有状态正确重置
    const completionClosedEvent = new CustomEvent('completionModalClosed', {
      detail: { part: selectedPart }
    });
    window.dispatchEvent(completionClosedEvent);
    
    console.log("关闭提分报告，触发重置事件:", selectedPart);
  };
  
  // 修改重置状态的函数，当用户最终关闭所有弹窗时调用
  const handleFinalizeTraining = () => {
    // 关闭所有弹窗
    setShowCompletionModal(false);
    setShowEndModal(false);
    setShowScoreReport(false);
    setShowDialogueHistory(false);
    setShowRoundDetail(false);
    
    // 触发两个事件：一个是通用重置事件，一个是专门针对完成弹窗关闭的事件
    // 通知子组件完全重置状态
    const resetEvent = new CustomEvent('resetTrainingState', {
      detail: { part: selectedPart }
    });
    window.dispatchEvent(resetEvent);
    
    // 添加新的事件，专门用于通知训练结束后重置
    const completionClosedEvent = new CustomEvent('completionModalClosed', {
      detail: { part: selectedPart }
    });
    window.dispatchEvent(completionClosedEvent);
    
    console.log("已触发训练完成重置事件:", selectedPart);
  };

  // 修改处理结束训练的函数
  const handleEndTraining = () => {
    console.log("handleEndTraining 被调用，当前消息数量:", currentMessages.length);
    console.log("当前消息内容:", currentMessages);
    
    // 保存当前对话作为一个轮次
    saveCurrentDialogue();
    
    setShowCompletionModal(false);
    setShowEndModal(true);
    
    // 使用函数式更新来确保获取最新的 currentMessages
    setCurrentRound((prevRound) => {
      const newRound = {
        part: selectedPart,
        date: new Date().toISOString().split('T')[0],
        time: new Date().toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }),
        messages: currentMessages
      };
      console.log("设置 currentRound，消息数量:", currentMessages.length);
      return newRound;
    });
    
    console.log("结束训练，已保存当前对话内容，当前模块:", selectedPart);
  };

  // 计算考试日期和剩余天数
  useEffect(() => {
    if (deadline) {
      const today = new Date();
      const examDay = new Date(today);
      examDay.setDate(today.getDate() + parseInt(deadline));
      
      const year = examDay.getFullYear();
      const month = String(examDay.getMonth() + 1).padStart(2, '0');
      const day = String(examDay.getDate()).padStart(2, '0');
      setExamDate(`${year}-${month}-${day}`);
      
      // 计算剩余天数
      const timeDiff = examDay.getTime() - today.getTime();
      const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      setDaysLeft(dayDiff > 0 ? dayDiff : 0);
    }
  }, [deadline]);

  // 添加查看轮次详情的函数
  const handleViewRoundDetail = (round) => {
    setSelectedRound(round);
    setShowRoundDetail(true);
  };

  // 添加关闭轮次详情的函数
  const handleCloseRoundDetail = () => {
    setShowRoundDetail(false);
    setSelectedRound(null);
  };

  // Add handler for exam button
  const handleStartExam = () => {
    setShowOptimizationModal(true);
  };

  // Add handler to close optimization modal
  const handleCloseOptimizationModal = () => {
    setShowOptimizationModal(false);
  };

  // Create a clone of children with additional props
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { 
        setShowCompletionModal, 
        setCurrentMessages,
        onRepeatTopic: handleRepeatCurrentTopic,
        onNewRound: handleStartNewRound,
        onEndTraining: handleEndTraining
      });
    }
    return child;
  });

  return (
    <div className={`training-page ${selectedPart === 'part2' ? 'part2-active' : ''}`}>
      <header className="training-header">
        <div className="user-info">
          <div className="welcome-text">{getPageTitle()}</div>
          {purpose && <div className="purpose">{language === 'en' ? 'Purpose: ' : '备考目的: '}{purpose}</div>}
        </div>
        <div className="header-nav">
          <span 
            className={`nav-link nav-button-blue ${selectedPart === 'part1' ? 'bold' : ''}`} 
            onClick={() => setSelectedPart('part1')}
          >
            {t('part1_training')}
          </span>
          <span 
            className={`nav-link nav-button-blue ${selectedPart === 'part2' ? 'bold' : ''}`} 
            onClick={() => setSelectedPart('part2')}
          >
            {t('part2_training')}
          </span>
          <span 
            className={`nav-link nav-button-blue ${selectedPart === 'part3' ? 'bold' : ''}`} 
            onClick={() => setSelectedPart('part3')}
          >
            {t('part3_training')}
          </span>
          <span className="nav-link nav-button-blue" onClick={() => window.location.href = '/'}>{t('return_to_home')}</span>
        </div>
      </header>

      <div className="training-content">
        <main className="training-main" style={{ marginLeft: 0, width: '100%' }}>
          {/* 只在登录状态下显示倒计时 */}
          {isLoggedIn && deadline && (
          <div className="countdown-calendar">
            <div className="calendar-content">
              <div className="days-left">{daysLeft}</div>
              <div className="days-text">{t('days')}</div>
            </div>
            <div className="exam-date">{t('exam_date')} {examDate}</div>
          </div>
          )}
          
          {childrenWithProps}
        </main>
      </div>

      {/* 修改弹窗层叠样式 */}
      {showCompletionModal && (
        <div className="completion-modal-overlay">
          <div className="completion-modal">
            <button onClick={handleCloseCompletionModal} className="close-modal-btn">&times;</button>
            <h3>{t('exercise_completed')}</h3>
            <p>{t('continue_or_end')}</p>
            <div className="completion-modal-buttons">
              <button onClick={handleStartNewRound} className="new-round-btn">
                {t('continue_practice')}
              </button>
              {selectedPart !== 'part1' && (
              <button onClick={handleRepeatCurrentTopic} className="repeat-topic-btn">
                {t('repeat_topic')}
              </button>
              )}
              <button onClick={handleEndTraining} className="end-training-btn">
                {t('end_training')}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* 添加第二个弹窗 - 结束训练后的选项 */}
      {showEndModal && (
        <div className="completion-modal-overlay">
          <div className="completion-modal">
            <button onClick={handleFinalizeTraining} className="close-modal-btn">&times;</button>
            <h3>{t('training_end_options')}</h3>
            <p>{t('view_history_or_report')}</p>
            <div className="completion-modal-buttons">
              <button onClick={handleViewHistory} className="view-history-btn">
                {t('view_conversation_history')}
              </button>
              <button onClick={handleViewReport} className="view-report-btn" style={{ marginTop: '10px' }}>
                {t('view_improvement_report')}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* 添加历史记录弹窗 */}
      {showDialogueHistory && (
        <div className="report-modal-overlay" style={{zIndex: 1100}}>
          <div className="dialogue-history-modal">
            <h3>{t('conversation_history')}</h3>
            <p className="history-notice">{t('history_save_notice')}</p>
            
            <div className="history-content">
              {dialogueHistory.length === 0 ? (
                <p className="no-history">暂无历史记录</p>
              ) : (
                <>
                  {/* 按日期分组显示，但只显示当前选中模块的历史记录 */}
                  {Array.from(new Set(dialogueHistory
                    .filter(item => item.part === selectedPart) // 只显示当前选中模块的历史记录
                    .map(item => item.date)))
                    .sort()
                    .reverse()
                    .map(date => (
                    <div key={date} className="history-date-group">
                      <div className="history-date-header">
                        <h4>{date}</h4>
                        <button onClick={() => handleExportHistory(date)} className="export-date-btn">
                          {t('export_records')}
                        </button>
                      </div>
                      <div className="history-rounds">
                        {dialogueHistory
                          .filter(item => item.date === date && item.part === selectedPart) // 只显示当前选中模块的历史记录
                          .sort((a, b) => b.id - a.id)
                          .map((record, index) => (
                          <div key={record.id} className="history-round" onClick={() => handleViewRoundDetail(record)}>
                            <div className="round-header">
                              <span className="round-title">{t('round')} {index + 1} ({record.time})</span>
                              <span className="message-count">{record.messages.length} {t('messages')}</span>
                            </div>
                            <div className="round-preview">
                              {record.messages.length > 0 ? 
                                `${record.messages[0].content.substring(0, 50)}${record.messages[0].content.length > 50 ? '...' : ''}` : 
                                '无对话内容'}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
            
            <div className="history-buttons">
              <button onClick={handleCloseHistory} className="close-history-btn">
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* 添加轮次详情弹窗 */}
      {showRoundDetail && selectedRound && (
        <div className="round-detail-overlay" style={{zIndex: 1200}}>
          <div className="round-detail-modal">
            <div className="round-detail-header">
              <h3>{t('conversation_detail')}</h3>
              <div className="round-info">
                <span>Part {selectedRound.part.replace('part', '')} {t('practice')}</span>
                <span>· {selectedRound.date} {selectedRound.time}</span>
              </div>
            </div>
            
            <div className="round-detail-content">
              {selectedRound.messages.map((message, index) => (
                <div key={index} className={`detail-message ${message.type}`}>
                  <div className="detail-avatar">
                    {message.type === 'mentor' ? (t('examiner') === 'Examiner' ? 'A' : '考') : (username ? username[0] : (t('candidate') === 'Candidate' ? 'U' : '生'))}
                  </div>
                  <div className="detail-message-content">
                    <div className="detail-sender">
                      {message.type === 'mentor' ? t('examiner') : (username || t('candidate'))}
                      <span className="detail-time">{message.time}</span>
                    </div>
                    <div className="detail-text">
                      {message.isVoice && message.displayTextHidden ? 
                        <div className="detail-voice-message">
                          <span className="detail-voice-icon">🔊</span> {t('voice_message')} ({t('hidden_text')})
                        </div> : 
                        message.content
                      }
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="round-detail-buttons">
              <button onClick={handleCloseRoundDetail} className="close-detail-btn">
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* 添加提分报告弹窗 - 使用单独的overlay */}
      {showScoreReport && (
        <div className="report-modal-overlay" style={{
          zIndex: 1100,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
          alignItems: 'flex-start',
          paddingTop: '30px',
          paddingBottom: '30px',
          overflow: 'auto'
        }}>
          <div className="score-report-modal" style={{
            position: 'relative',
            backgroundColor: '#fff',
            borderRadius: '8px',
            width: '90%',
            maxWidth: '1000px',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
          }}>
            <button 
              onClick={handleCloseReport} 
              className="close-modal-btn" 
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666',
                zIndex: 1
              }}
            >
              &times;
              </button>
            <ScoreReport 
              currentRound={currentRound}
              selectedPart={selectedPart}
              username={username || (language === 'en' ? 'Student' : '考生')}
              userData={localStorage.getItem('talktastic_user') ? JSON.parse(localStorage.getItem('talktastic_user')) : null}
            />
          </div>
        </div>
      )}

      {/* Add optimization modal */}
      {showOptimizationModal && (
        <div className="report-modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1100
        }}>
          <div className="optimization-modal" style={{
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '30px',
            maxWidth: '600px',
            width: '90%',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
          }}>
            <h3 style={{ 
              textAlign: 'center',
              marginBottom: '20px',
              borderBottom: '1px solid #eee',
              paddingBottom: '15px',
              fontSize: '22px'
            }}>
              {t('mock_exam')}
            </h3>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '80px', marginBottom: '20px' }}>🔧</div>
              <h2 style={{ marginBottom: '15px' }}>{t('optimizing')}</h2>
              <p style={{ fontSize: '16px', color: '#666', maxWidth: '500px' }}>
                {t('optimization_message')}
              </p>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '20px'
            }}>
              <button onClick={handleCloseOptimizationModal} style={{
                padding: '10px 20px',
                backgroundColor: '#4a90e2',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '16px'
              }}>
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainingContainer; 